import { KeyValue, PaginatedModel } from "@skv/core";

export enum AgencyEntityStatus {
  Active,
  Archived,
}

export type AgencyEntityStatusKeyValue = {
  id: AgencyEntityStatus;
  name: string;
};

export interface AgencyEntitySearchQuery {
  ascending: boolean;
  page: number;
  search: string;
  sortedBy: number;
}

export type AgencyEntityListResult = PaginatedModel<AgencyEntity> & {
  agencyName: string;
};

export interface AgencyEntity {
  id: number;
  name: string;
  dateCreated: string;
  managerName: string;
  managerEmail: string;
  type: string;
}

export interface AgencyEntityListViewModel {
  filteredByStatus: AgencyEntityStatusKeyValue;
  filteredByType: KeyValue[];
  form: AgencyEntitySearchQuery;
  listResult: AgencyEntityListResult;
  requestConnectionUrl: string;
}

export type EntityItem = KeyValue & {
  type: EntityItemType | null;
};

type ValueOf<T> = T[keyof T];

type EntityItemType = {
  isManaged: boolean;
  isSupported: boolean;
  name: keyof typeof AgencyEntityTypeEnum;
  value: ValueOf<typeof AgencyEntityTypeEnum>;
};

export enum AgencyEntityTypeEnum {
  Managed = 0,
  Supported,
}
